// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"3abccf1c","41":"0641b52d","68":"72141e37","297":"3293b0fb","345":"b079ddec","686":"3f5e6060","798":"35187405","915":"fb265a19"}[chunkId] + ".chunk.js";
};